import { Button, Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import { toJalaali, toGregorian, jalaaliToDateObject } from 'jalaali-js';
import { CloseOutlined, DeleteOutlined, DoubleLeftOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, PrinterOutlined, RollbackOutlined, SearchOutlined } from '@ant-design/icons';
import { GetAllInCategory_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { GetAll_BetweenDate_Reserve_Api } from '../../API/ReserveApi';
import SizeContext from 'antd/es/config-provider/SizeContext';

export const ObjectInstanceCalendarComponent = ({ setLoading, showMessage, categoryId, onBackClick }) => {
  // =================================================================
  const [objectInstances, setObjectInstances] = useState([]);
  const [reserves, setReserves] = useState([]);
  const [from_Shamsi, setFrom_Shamsi] = useState(null);
  const [to_Shamsi, setTo_Shamsi] = useState(null);
  const [daysCount, setDaysCount] = useState(null);
  const [dateRange, setDateRange] = useState(null);

  // ======================================================================
  useEffect(() => {
    loadDataObjectInstances();
  }, []);
  // ======================================================================
  const loadDataObjectInstances = async () => {
    setLoading(true);
    try {
      const data = await GetAllInCategory_ObjectInstance_Api(categoryId);
      setLoading(false);
      if (data.messageStatus == "Successful") {
        console.log(data.messageData.data)
        setObjectInstances(data.messageData.data);

      }
      else {
        showMessage(data.message, "error")
      }
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // =================================================================
  const submitSearch = async () => {
    try {
      const params = {
        fromDate_Shamsi: from_Shamsi,
        toDate_Shamsi: to_Shamsi,
        categoryId: categoryId,

      }
      setLoading(true);

      setDaysCount(getDaysBetweenDates(from_Shamsi, to_Shamsi))
      setDateRange(getDateRange(from_Shamsi, to_Shamsi));
      let data = await GetAll_BetweenDate_Reserve_Api(params);
      if (data.messageStatus == "Successful") {
        setReserves(data.messageData.data);
      }
      else
        showMessage(data.message, "error")
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
      showMessage(error.message, "error")
      // showMessage("خطا در ارتباط با سرور", "error")
    }
  };
  // =================================================================
  const getDaysBetweenDates = (startDate, endDate) => {
    const start = startDate.split('-').map(Number);
    const end = endDate.split('-').map(Number);
    const startJalaali = toGregorian(start[0], start[1], start[2]);
    const endJalaali = toGregorian(end[0], end[1], end[2]);
    const startTime = new Date(startJalaali.gy, startJalaali.gm - 1, startJalaali.gd).getTime();
    const endTime = new Date(endJalaali.gy, endJalaali.gm - 1, endJalaali.gd).getTime();
    const diffTime = Math.abs(endTime - startTime);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays + 1;
  };

  const getDateRange = (startDate, endDate) => {
    const dates = [];
    const start = startDate.split('-').map(Number); // تبدیل تاریخ شروع به آرایه‌ای از اعداد
    const end = endDate.split('-').map(Number); // تبدیل تاریخ پایان به آرایه‌ای از اعداد

    let currentDate = { jy: start[0], jm: start[1], jd: start[2] }; // تاریخ جاری به صورت شمسی

    while (
      currentDate.jy < end[0] ||
      (currentDate.jy === end[0] && currentDate.jm < end[1]) ||
      (currentDate.jy === end[0] && currentDate.jm === end[1] && currentDate.jd <= end[2])
    ) {
      dates.push({ ...currentDate }); // اضافه کردن تاریخ جاری به آرایه
      currentDate.jd++; // افزایش روز

      // بررسی اینکه آیا روز از تعداد روزهای ماه بیشتر شده است
      const maxDaysInMonth = jalaaliMonthLength(currentDate.jy, currentDate.jm);
      if (currentDate.jd > maxDaysInMonth) {
        currentDate.jd = 1;
        currentDate.jm++;

        // بررسی اینکه آیا ماه از ۱۲ بیشتر شده است
        if (currentDate.jm > 12) {
          currentDate.jm = 1;
          currentDate.jy++;
        }
      }
    }

    return dates;
  };
  // تابع کمکی برای چک کردن اینکه یک تاریخ شمسی بین 2 تاریخ شمسی باشد
function isShamsiDateInRange(checkDate, startDate, endDate) {
  const [checkYear, checkMonth, checkDay] = checkDate.split('-').map(Number);
  const [startYear, startMonth, startDay] = startDate.split('-').map(Number);
  const [endYear, endMonth, endDay] = endDate.split('-').map(Number);
  
  // ایجاد timestamp عددی برای مقایسه
  const checkTimestamp = checkYear * 10000 + checkMonth * 100 + checkDay;
  const startTimestamp = startYear * 10000 + startMonth * 100 + startDay;
  const endTimestamp = endYear * 10000 + endMonth * 100 + endDay;
  
  return checkTimestamp >= startTimestamp && checkTimestamp <= endTimestamp;
}
  // تابع کمکی برای محاسبه تعداد روزهای یک ماه شمسی
  const jalaaliMonthLength = (jy, jm) => {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    if (jalaaliIsLeapYear(jy)) return 30;
    return 29;
  };

  // تابع کمکی برای بررسی سال کبیسه شمسی
  const jalaaliIsLeapYear = (jy) => {
    return (((jy - (jy > 0 ? 474 : 473)) % 2820) * 682 % 2816 < 682);
  };

    const getCellContent = (roomId, date) => {
    //  console.log('date structure:', date);
  //console.log('date type:', typeof date);
  //console.log('date properties:', Object.keys(date));
  const dateParts = date.split('-'); // ["1404", "7", "19"]
    const year = dateParts[0];
    const month = dateParts[1].padStart(2, '0'); // "7" -> "07"
    const day = dateParts[2].padStart(2, '0'); // "19" -> "19"
  
      const reservationsForRoom = reserves.filter(reserve => reserve.objectInstanceId === roomId);
      let activeReservations = []; // لیست رزروهای فعال در این روز
    
      // بررسی رزروهای فعال در این روز
      /*reservationsForRoom.forEach(reserve => {
        const reserveStart = reserve.from_Shamsi;
        const reserveEnd = reserve.to_Shamsi;
        if (date >= reserveStart && date <= reserveEnd) {
          activeReservations.push(reserve);
        }
      });
      */
     reservationsForRoom.forEach(reserve => {
  if (isShamsiDateInRange(date, reserve.from_Shamsi, reserve.to_Shamsi)) {
    activeReservations.push(reserve);
  }
});
      // اگر هیچ رزروی نبود
      if (activeReservations.length === 0) {
        // تبدیل رشته "1404-7-19" به "07/19"
    

        return { text: `${month}/${day}`, color: 'white' }; // متن پیش‌فرض و رنگ سفید
      }
    
      // اگر فقط یک رزرو بود
      if (activeReservations.length === 1) {
//        return { text: activeReservations[0].trackingCode, color: 'red' }; // کد رهگیری و رنگ قرمز
        return { text: `${month}/${day}`, color: 'red' }; // کد رهگیری و رنگ قرمز

      }
    
      // اگر بیش از یک رزرو بود
      if (activeReservations.length > 1) {
        // بررسی اینکه آیا این روز، آخرین روز همپوشانی است یا خیر
        let isLastOverlapDay = false;
    
        activeReservations.forEach(reserve => {
          if (date === reserve.to_Shamsi) {
            isLastOverlapDay = true;
          }
        });
    
        // اگر آخرین روز همپوشانی باشد
        if (isLastOverlapDay) {
/*          return {
            text: activeReservations.map(reserve => reserve.trackingCode).join(', '), // کدهای رهگیری با کاما جدا شده
            color: 'blue', // آبی (تداخل)
          };
          */
          return {
            text: `${month}/${day}`, // کدهای رهگیری با کاما جدا شده
            color: 'blue', // آبی (تداخل)
          };
        }
    
        // در غیر این صورت، روزهای قبلی همپوشانی
/*        return {
          text: activeReservations.map(reserve => reserve.trackingCode).join(', '), // کدهای رهگیری با کاما جدا شده
          color: 'brown', // قهوه‌ای (خطا)
        };
        */
        return {
          text: activeReservations.map(reserve => reserve.trackingCode).join(', '), // کدهای رهگیری با کاما جدا شده
          color: 'brown', // قهوه‌ای (خطا)
        };
      }
    };
  

  // =================================================================


  return (
    <>
      <Row className='sectionTitle' style={{ marginBottom: '10px' }}>
        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
          <Button
            className='step-prev-btn btn-light'
            onClick={() => { onBackClick() }}
          >
            <DoubleRightOutlined />
            <span className='step-prev-btn-title'>
              بازگشت
            </span>
          </Button>

        </Col>
        <Col xs={10} sm={10} md={10} lg={16} xl={16}>
          <h2>
            گزارش وضعیت اتاق ها
          </h2>
        </Col>
        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
          <Button
            className={'step-next-btn btn-primary'}
            onClick={() => { window.print() }}
          >
            <span className='step-next-btn-title'>
              چاپ
            </span>
            <PrinterOutlined />
          </Button>

        </Col>
      </Row>

      <div className='container no-print'>
        <Row>
          <Col xs={12} sm={12} md={3} lg={2} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
            از تاریخ:
          </Col>
          <Col xs={12} sm={12} md={9} lg={5} xl={5}>
            <JalaliLocaleListener />
            <DatePickerJalali placeholder={"تاریخ"} onChange={(date, dateString) => { setFrom_Shamsi(dateString); }} />
          </Col>
          <Col xs={24} sm={24} md={1} lg={1} xl={1} >
          </Col>
          <Col xs={12} sm={12} md={3} lg={2} xl={2} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
            تا تاریخ:
          </Col>
          <Col xs={12} sm={12} md={9} lg={5} xl={5}>
            <JalaliLocaleListener />
            <DatePickerJalali placeholder={"تاریخ"} onChange={(date, dateString) => { setTo_Shamsi(dateString); }} />
          </Col>
          <Col xs={24} sm={24} md={1} lg={1} xl={1} >
          </Col>
          <Col xs={12} sm={12} md={3} lg={8} xl={8} style={{ fontWeight: 'bold', paddingTop: '7px' }}>
            <span>
              راهنمای رنگ:
            </span>
            <table style={{ display: 'inline', right: '10px' }}>
              <tr>
                <td><div style={{ backgroundColor: 'red', width: '40px', height: '15px', border: '1px solid #cdcdcd' }}></div></td>
                <td><div style={{ backgroundColor: 'white', width: '40px', height: '15px', border: '1px solid #cdcdcd' }}></div></td>
                <td><div style={{ backgroundColor: 'blue', width: '40px', height: '15px', border: '1px solid #cdcdcd' }}></div></td>
                <td><div style={{ backgroundColor: 'brown', width: '40px', height: '15px', border: '1px solid #cdcdcd' }}></div></td>
              </tr>
              <tr style={{ textAlign: 'center', fontSize: '10px' }}>
                <td>پر</td>
                <td>خالی</td>
                <td>تداخل</td>
                <td>خطا</td>
              </tr>
            </table>
          </Col>
        </Row>
      </div>
      <Row style={{ padding: '10px' }}>
        <Col span={20}></Col>
        <Col span={4}>
          <Button className='btn-success' onClick={() => submitSearch()} style={{ width: '95%' }}> <SearchOutlined /> جستجو</Button>
        </Col>
      </Row>
      <div className='container'>
        {dateRange && objectInstances ?
          <div>
          <table border="1">
            <thead>
              <tr>
                <th  >اتاق</th>
                {dateRange.map((date, index) => (
                  <th key={index} style={{textAlign:'center',fontSize:'10px',padding:'4px'}}>{date.jm}/{date.jd}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {objectInstances.map(room => (
                <tr key={room.id} style={{textAlign:'center',fontSize:'10px'}}>
                  <td style={{textWrap:'nowrap'}} >{room.title}</td>
                  {dateRange.map((date, index) => {
                    const dateString = `${date.jy}-${date.jm}-${date.jd}`;
                    const cellContent = getCellContent(room.id, dateString);
                    return (
                      <td key={index} style={{ backgroundColor: cellContent.color ,padding:'3px',textWrap:'nowrap'}}>
                        {cellContent.text} {/* نمایش کد رهگیری یا متن پیش‌فرض */}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div> : <></>}
      </div>
    </>
  )
}

